// Styles
import 'vuetify/styles';

// Vuetify
import type { IconOptions, ThemeDefinition, VuetifyOptions } from 'vuetify';
import { createVuetify } from 'vuetify';
import colors from 'vuetify/lib/util/colors';
import { fa } from 'vuetify/iconsets/fa';
import aliases from '@/plugins/vuetify-font-awesome';

const light: ThemeDefinition = {
  dark: false,
  colors: {
    surface: '#ffffff',
    'on-surface': '#494949',
    primary: '#ff1595',
    error: '#ff5252',
    info: '#2196f3',
    warning: '#fb8c00',
    'highlight-background': '#ffffa7',
    'highlight-focus-background': '#ffff00',
    'highlight-text': '#494949',
    tonedBackground: colors.grey.lighten5,
    accentedBackground: colors.grey.lighten4,
    footerBackground: colors.grey.lighten3,
  },
};

const dark: ThemeDefinition = {
  dark: true,
  colors: {
    surface: '#000000',
    'on-surface': '#e2e2e2',
    primary: '#ff1595',
    error: '#ff5252',
    info: '#2196f3',
    warning: '#fb8c00',
    'highlight-background': '#248b4d',
    'highlight-focus-background': '#38d878',
    'highlight-text': '#000000',
    tonedBackground: colors.grey.darken3,
    accentedBackground: colors.grey.darken2,
    footerBackground: colors.grey.darken4,
  },
};

const lightZekerArbo: ThemeDefinition = {
  dark: false,
  colors: {
    surface: '#ffffff',
    'on-surface': '#494949',
    primary: '#27483D',
    error: '#ff5252',
    info: '#2196f3',
    warning: '#fb8c00',
    'highlight-background': '#ffffa7',
    'highlight-focus-background': '#ffff00',
    'highlight-text': '#494949',
    tonedBackground: colors.grey.lighten5,
    accentedBackground: colors.grey.lighten4,
    footerBackground: colors.grey.lighten3,
  },
};

const darkZekerArbo: ThemeDefinition = {
  dark: true,
  colors: {
    surface: '#000000',
    'on-surface': '#e2e2e2',
    primary: '#A9BE4A',
    error: '#ff5252',
    info: '#2196f3',
    warning: '#fb8c00',
    'highlight-background': '#248b4d',
    'highlight-focus-background': '#38d878',
    'highlight-text': '#000000',
    tonedBackground: colors.grey.darken3,
    accentedBackground: colors.grey.darken2,
    footerBackground: colors.grey.darken4,
  },
};

export const themes = { light, dark, lightZekerArbo, darkZekerArbo };

export const icons: IconOptions = {
  defaultSet: 'fa',
  aliases,
  sets: { fa },
};

export default (options: VuetifyOptions = {}) =>
  createVuetify({
    icons,
    theme: {
      cspNonce: '1zT7e0J3e09r9QmVqHui',
      defaultTheme: 'light',
      variations: {
        colors: ['primary', 'secondary'],
        darken: 4,
        lighten: 0,
      },
      themes,
    },
    ...options,
  });
